import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Text, Title, VIPSO_RED } from '@vipso/shared';

export function LoginLandingLayout({
  children,
  logoUrl,
  title,
  subtitle,
}: {
  children: ReactNode;
  logoUrl?: string | null;
  title?: string;
  subtitle?: string;
}) {
  const { t } = useTranslation();
  const logoSrc = logoUrl || '/brand/logo-sm.svg';
  const resolvedTitle = title ?? t('auth.login');
  const resolvedSubtitle = subtitle ?? t('auth.signInSubtitle');

  return (
    <Box
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px 16px',
        background: '#ffffff',
      }}
    >
      <Box style={{ width: '100%', maxWidth: 420 }}>
        <Stack align="center" gap="xs" mb="xl">
          <img
            src={logoSrc}
            alt="VIPSo"
            style={{
              width: 150,
              height: 200,
              objectFit: 'contain',
              display: 'block',
            }}
          />
          <Title order={2} ta="center" c="navy.9" mt="md">
            {resolvedTitle}
          </Title>
          <Text size="xs" c="dimmed" ta="center">
            {resolvedSubtitle}
          </Text>
        </Stack>
        {children}
      </Box>
    </Box>
  );
}

export const loginPrimaryButtonStyle = {
  marginTop: 20,
  width: '100%',
  borderRadius: 10,
  backgroundColor: VIPSO_RED,
} as const;
